module.exports = __webpack_public_path__ + "static/media/ZT4.93fb89af.jpg";